<script lang="ts" setup>
import { RoutesEnum } from '~/enums'
import type { SidebarItem } from '~/types/index'

const route = useRoute()

defineProps({
  isCollapsed: {
    type: Boolean,
    default: false,
  },
  item: {
    type: Object as () => SidebarItem,
    required: true,
  },
})

const isOpen = ref(false)
</script>
<template>
  <BaseMenu
    v-model="isOpen"
    is-use-model-value
    :items="item.items || []"
    menu-class="desktop-sidebar__menu"
    location="end"
    open-on-hover
    :open-on-focus="false"
    :z-index="2100"
    :offset="[0, 254]"
  >
    <VListItem
      :prepend-icon="item.icon"
      :title="item.title"
      :value="item.key"
      :class="{
        'v-list-item--selected':
          route.path != RoutesEnum.Home && route.fullPath.includes(item.key),
      }"
      @click="isOpen = false"
    >
      <template v-if="!isCollapsed" #append>
        <i class="icon-right" />
      </template>
    </VListItem>
  </BaseMenu>
</template>
